import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccumulationChartModule, ChartModule } from '@syncfusion/ej2-angular-charts';
import { DashboardComponent } from './dashboard.component';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { SkeletonModule } from '@syncfusion/ej2-angular-notifications';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { AnimationComponent } from "../../core/loading-animation/animation/animation.component";
import { LoadingAnimationModule } from "../../core/loading-animation/loading-animation.module";




@NgModule({
  declarations: [
    DashboardComponent
  ],
  imports: [
    CommonModule,
    ChartModule,
    AccumulationChartModule,
    GridModule,
    SkeletonModule,
    ButtonModule,
    AnimationComponent,
    LoadingAnimationModule
],
  exports: [DashboardComponent]
})
export class DashboardModule { }
